<script setup lang="ts">
defineProps<{ loading?: boolean }>()
const model = defineModel<string>('modelValue')
const search = ref(model.value)
const updateValue = useDebounceFn(() => {
  model.value = search.value
}, 300)

watch(search, () => updateValue())
</script>

<template>
  <form class="sticky top-0 bg-white" @submit.prevent.stop="() => null">
    <label class="flex items-center px-2 p-1 gap-2 bg-grayLighter border border-softGray rounded-full focus-within:outline-darkerGray ">
      <div v-if="!loading" class="i-mdi:magnify  w-4 h-4 color-darkGray " />
      <div v-else class="i-mdi:loading animate-rotate-in w-4 h-4 color-darkGray " />

      <input v-model="search" placeholder="Search" class="min-w-0 w-full bg-transparent focus:outline-none" tabindex="1">
    </label>
  </form>
</template>
